<h2 mat-dialog-title class="text-lg font-bold mb-1"> {{ isEditMode ? 'Editar Registro' : 'Nuevo Registro' }}</h2>
<mat-dialog-content class="modal-content">
    <form #createForm="ngForm">
        <div class="grid grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Código</mat-label>
                <input matInput [(ngModel)]="currentCreatePaymentBrand.code" name="code" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Nombre</mat-label>
                <input matInput [(ngModel)]="currentCreatePaymentBrand.name" name="name"
                    oninput="this.value = this.value.toUpperCase()" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Tasa de comisión bancaria (%)</mat-label>
                <input matInput type="number" [(ngModel)]="currentCreatePaymentBrand.commission" name="commission"
                    required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Retención de impuesto (%)</mat-label>
                <input matInput type="number" [(ngModel)]="currentCreatePaymentBrand.taxRetainment" name="taxRetainment"
                    required>
            </mat-form-field>
        </div>
        <div class="border border-gray-300 rounded-lg p-4 mb-4">
            <h3 class="text-sm font-bold mb-4">DATOS CONTABLES MARCA</h3>
            <div class="grid grid-cols-3 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cuenta contable</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.accountingAccount" name="accountingAccount"
                        required>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Centro de costo</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.costCenter" name="costCenter">
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Clave contable</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.accountingKey" name="accountingKey">
                </mat-form-field>
            </div>
        </div>

        <div class="border border-gray-300 rounded-lg p-4 mb-4">
            <h3 class="text-sm font-bold mb-4">DATOS CONTABLES COMISIÓN</h3>
            <div class="grid grid-cols-3 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cuenta contable</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.com_accountingAccount" name="com_accountingAccount"
                        required>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Centro de costo</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.com_costCenter" name="com_costCenter">
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Clave contable</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.com_accountingKey" name="com_accountingKey">
                </mat-form-field>
            </div>
        </div>

        <div class="border border-gray-300 rounded-lg p-4 mb-4">
            <h3 class="text-sm font-bold mb-4">DATOS CONTABLES RETENCIÓN</h3>
            <div class="grid grid-cols-3 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cuenta contable</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.ret_accountingAccount" name="ret_accountingAccount"
                        required>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Centro de costo</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.ret_costCenter" name="ret_costCenter">
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Clave contable</mat-label>
                    <input matInput [(ngModel)]="currentCreatePaymentBrand.ret_accountingKey" name="ret_accountingKey">
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!createForm.valid" class="justify-end">
        {{ isEditMode ? 'Actualizar' : 'Guardar' }}
    </button>
</mat-dialog-actions>